module.exports = __webpack_public_path__ + "static/media/file_dashboard.fe9adcae.svg";